import React from 'react';

import { OpsgenieIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <OpsgenieIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useOpsgenie = (fallbackUrl: FallbackUrl, options: GlobalShortcutConfiguration = {}) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.OPSGENIE,
		analyticsName: Products.OPSGENIE,
		...options,
	});
